import * as React from "react";
import { IconAdd } from "../icons/IconAdd";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";


export const IconButtonAdd: React.FC<MprcIconButtonProps> = ({ title, children, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonAdd.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconAdd fixedWidth  />
            {children}
        </MprcIconButton>
    );
};
